import { CaretUpOutlined, CloseOutlined } from '@vindr/icons';
import { Button, Spin } from 'antd';
import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadMinimizeProps } from './context/type';

const UploadMinimize = ({
  dispatch,
  failItem,
  fileList,
  handleClose,
  isFinish,
  isReady,
  remainingCount,
  show,
  uploading,
}: UploadMinimizeProps) => {
  const { t } = useTranslation('Vindoc');
  const fileLength = useMemo(() => fileList.length, [fileList]);
  const fileText = useMemo(() => (fileLength > 1 ? 'files' : 'file'), [fileLength]);

  const headerTitle = useMemo(() => {
    if (uploading) return `Uploading ${remainingCount} / ${fileLength} ${fileText}`;
    if (isReady) return `Ready for upload ${fileLength} ${fileText}`;
    if (isFinish) return `Uploaded ${fileLength - failItem.length} ${fileText}`;

    return 'Upload Files';
  }, [uploading, remainingCount, fileLength, fileText, isReady, isFinish, failItem]);

  const handleMinimize = useCallback(
    () => dispatch({ type: 'setIsMinimize', payload: false }),
    [dispatch]
  );

  return show ? (
    <section className="upload-minimize ml-auto mt-auto max-h-80 min-h-14 w-3/4 rounded-sm bg-[#035585] p-4 text-black dark:text-white md:w-full">
      <header className="flex items-center justify-between">
        <div className="title">
          {t(headerTitle)}
          {uploading && <Spin className="ml-2" />}
        </div>
        <div className="action flex">
          <Button
            className="mr-2 w-[20px] fill-[#000] p-0 dark:fill-[#fff]"
            type="text"
            size="small"
            onClick={handleMinimize}
          >
            <CaretUpOutlined className="text-lg leading-4" />
          </Button>
          <Button
            type="text"
            className=" w-[20px] fill-[#000] p-0 dark:fill-[#fff]"
            size="small"
            onClick={handleClose}
          >
            <CloseOutlined className="text-lg leading-4" />
          </Button>
        </div>
      </header>
    </section>
  ) : null;
};

export default memo(UploadMinimize);
